// extracted by mini-css-extract-plugin
export default {"gredient":"style_gredient__SrCYR","register":"style_register__WgEPJ","logoContainer":"style_logoContainer__FlRi-","logo":"style_logo__i-ILG"};